/*
  eslint
    no-var: off
    object-shorthand: off
*/

var debug = require('debug');

var logError = debug('exchange:logging:error');
var logDebug = debug('exchange:logging:debug');
var logInfo = debug('exchange:logging:info');
var logWarn = debug('exchange:logging:warn');

function logger() {
  return {
    error: function errorLogger(args) {
      logError(args);
    },
    debug: function debugLogger(args) {
      logDebug(args);
    },
    info: function infoLogger(args) {
      logInfo(args);
    },
    warn: function warnLogger(args) {
      logWarn(args);
    }
  };
}

module.exports = {
  logger: logger,
  logError: logError
};
